import React, { useEffect, useRef, useState } from "react";

const DigirepInfo = (props) => {
  const infoForm = useRef(null);
  const [digirep, setDigirep] = useState({});
  const [timeline, setTimeline] = useState("TODAY");
  const revenueInfoCardData = [
    {
      title: "Total Digirep",
      count: digirep?.totalConnectors || 0,
      amount: digirep?.repaymentAmt || 0,
      icon: imagepaths.moneyBagIcon,
    },
    {
      title: "Completed Profile",
      count: digirep?.totalConnectorsOnboarded || 0,
      amount: digirep?.processingFeeAmt || 0,
      icon: imagepaths.moneyBagIcon,
    },
    {
      title: "Pending Profile",
      count: digirep?.totalConnectorsPending || 0,
      amount: digirep?.principleAmt || 0,
      icon: imagepaths.moneyBagIcon,
    },
    {
      title: "Newly Onboarded",
      count: digirep?.totalConnectorsNewlyOnboarded || 0,
      amount: digirep?.interestAmt || 0,
      icon: imagepaths.moneyBagIcon,
    },
  ];
  // REVENUE INFO

  const getPortfolioMetricsDigirep = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }
    props.apis.apiGetPortfolioMetricsDigirep(data, payload).then((res) => {
      setDigirep(res);
    });
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "digirep-column-start_date",
      "digirep-column-end_date",
      "digirep-column-search_btn",
      "digirep-column-reset_btn",
    ];
    console.log({ val });
    if (val === "CUSTOM") {
      showInputs(inputs);
      setDigirep({});
    } else {
      hideInputs(inputs);
      setTimeline(val);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      start_date: new Date(data?.start_date).toISOString(),
      end_date: new Date(data?.end_date).toISOString(),
    };
    getPortfolioMetricsDigirep(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "digirep-column-start_date",
      "digirep-column-end_date",
      "digirep-column-search_btn",
      "digirep-column-reset_btn",
    ];
    hideInputs(inputs);
    getPortfolioMetricsDigirep({}, "TODAY");
  };

  useEffect(() => {
    // DIGIREP PORTFOLIO
    getPortfolioMetricsDigirep();
  }, [timeline]);

  props.$setNode({
    props,
    digirep,
  });
  return (
    <>
      <div className="mb-4 dashboard_form_box">
        <div className="d-flex flex-wrap justify-content-between">
          <h2 className="fs-4 mt-2">DigiRep Info.</h2>
          <div className="form_outer w-100 mw-200">
            <AppForm
              ref={infoForm}
              onSubmit={(...args) => onSearch(...args)}
              className="row justify-content-end"
            >
              <div className="col-12" id="column-timeline">
                <AppInputFocus
                  type="select"
                  name="timeline"
                  label="Time Line"
                  options={_enum.OVERALL_DETAIL}
                  onChange={(...args) => handleDateChange(...args)}
                  defaultValue={"TODAY"}
                  placeholder="Time Line"
                ></AppInputFocus>
              </div>
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
                id="digirep-column-start_date"
              >
                <AppInputFocus
                  type="date"
                  name="start_date"
                  label="Start Date"
                  placeholder="Start Date"
                  required={true}
                ></AppInputFocus>
              </div>
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
                id="digirep-column-end_date"
              >
                <AppInputFocus
                  type="date"
                  name="end_date"
                  label="End Date"
                  placeholder="End Date"
                  required={true}
                ></AppInputFocus>
              </div>
              <div
                className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
                id="digirep-column-search_btn"
              >
                <button type="submit" className="btn btn-primary search_btn">
                  <i className="fa fa-search"></i>
                  <span>Search</span>
                </button>
              </div>
              <div
                className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
                id="digirep-column-reset_btn"
              >
                <button
                  type="button"
                  className="btn btn-primary search_btn"
                  onClick={(...args) => resetSearchForm(...args)}
                >
                  <i class="fa-solid fa-filter-circle-xmark"></i>
                  <span>Reset</span>
                </button>
              </div>
            </AppForm>
          </div>
        </div>
        <div className="row pt-0">
          {revenueInfoCardData &&
            revenueInfoCardData.map((revenue) => {
              return (
                <>
                  <div
                    className="col-xl-3 col-sm-6"
                    // onClick={(...args) => navigate(revenue?.path)}
                  >
                    <div className="card dashboard_card application_card revenue_info_card">
                      <div className="card-body">
                        <div className="content">
                          <p className="card_label">{revenue?.title}</p>
                          <p className="count">{revenue?.count}</p>
                        </div>
                        <div className="icon_container">
                          {/* <div className="icon">
                            <img src={revenue?.icon} alt="icon image" />
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default constore(DigirepInfo);
